import { formatCallDuration } from '@/lib/format';

export interface ConsumptionSummaryItem {
  type: string;
  countQuantity: number;
}

export interface ConsumptionStats {
  dataUsedGo: number;
  dataTotalGo: number;
  /** 0 when the plan has no data envelope (unlimited). */
  dataPercentage: number;
  voiceDuration: { value: string; label: string };
  smsCount: number;
  mmsCount: number;
}

/** Derives the current-month consumption cards from the raw summary rows. */
export function deriveConsumptionStats(
  items: ConsumptionSummaryItem[],
  dataLimitMo: number,
): ConsumptionStats {
  const dataUsedBytes =
    items.find((i) => i.type === 'data')?.countQuantity || 0;

  return {
    dataUsedGo: Math.round(dataUsedBytes / (1024 * 1024)),
    dataTotalGo: dataLimitMo / 1000,
    dataPercentage:
      dataLimitMo > 0 ? (dataUsedBytes / (dataLimitMo * 1000)) * 100 : 0,
    voiceDuration: formatCallDuration(
      Math.round(
        (items.find((i) => i.type === 'voice')?.countQuantity || 0) / 60,
      ),
    ),
    smsCount: items.find((i) => i.type === 'sms')?.countQuantity || 0,
    mmsCount: items.find((i) => i.type === 'mms')?.countQuantity || 0,
  };
}
